<template>
  <div>
    <div class="app-head">
      <div class="title">{{ $store.state.sys.title }}</div>
      <div class="menu">
        <div class="menu-item" :class="{ 'active': key == '/printandship' }" @click="menuClick('printandship')">打印发货
        </div>
        <div class="menu-item" :class="{ 'active': key == '/freeprint' }" @click="menuClick('freeprint')">自由打印</div>
        <div class="menu-item" :class="{ 'active': key == '/actionlog' }" @click="menuClick('actionlog')">操作日志</div>
        <div class="menu-item" :class="{ 'active': key == '/setting' }" @click="menuClick('setting')">系统设置</div>
      </div>
      <div class="action">
        <div></div>
        <div style="font-size: 22px;margin-right: 10px;">
          <i class="el-icon-bell" style="cursor: pointer;" @click="openMsg"></i>
        </div>
        <div class="logo">
          <el-image :src="mallInfo.logo"></el-image>
        </div>
        <div class="user-info">
          <el-popover placement="bottom-end" title="用户信息" trigger="click">
            <div class="user-info-box">
              <div class="content" @click="() => { showMall = false }">
                <div class="item">
                  <div class="label">账号平台：</div>
                  <div class="item-content">{{ mallInfo.sysType }}</div>
                </div>
                <div class="item" v-if="mallInfo.userName">
                  <div class="label">登录账号：</div>
                  <div class="item-content">{{ mallInfo.userName }}</div>
                </div>
                <div class="item">
                  <div class="label">店铺名称：</div>
                  <div class="item-content text-hidden" :title="mallInfo.mallName">{{ mallInfo.mallName }}</div>
                </div>
                <div class="item">
                  <div class="label">店铺秘钥：</div>
                  <div class="item-content text-hidden" :title="mallInfo.secretKey">
                    <span id="key" @mouseover="onSelectText">{{ mallInfo.secretKey }}</span>
                  </div>
                </div>
                <div class="item">
                  <div class="label">到期时间：</div>
                  <div class="item-content">{{ mallInfo.expirationDate }}</div>
                </div>
                <div class="item">
                  <div class="label">剩余时间：</div>
                  <div class="item-content"><span class="day">{{ mallInfo.expirationDate | interval_days }}</span>天
                  </div>
                </div>
              </div>
              <div class="footer-btn">
                <el-popover placement="left" trigger="click" v-model="showMall" v-if="mallList.length > 1">
                  <div class="mall-box">
                    <div v-for="(i, k) in mallList" :key="k" class="mall-item" @click="selectMall(i)">
                      <div class="left">{{ i.mallName }}</div>
                      <div class="right">
                        <template v-if="i.day >= 0"><span class="day">{{ i.day }}</span>天</template>
                        <template v-else><span class="day">已过期</span></template>
                      </div>
                    </div>
                  </div>
                  <div slot="reference" class="btn">切换店铺</div>
                </el-popover>
                <div class="btn" @click="logout">退出账号</div>
              </div>
            </div>
            <div slot="reference" class="text-hidden">{{ mallInfo.mallName }}</div>
          </el-popover>
        </div>
      </div>
    </div>
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews" :exclude="exclude">
          <router-view v-if="refresh" :key="key" />
        </keep-alive>
      </transition>
    </section>
  </div>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {
      refresh: true,
      exclude: null,
      showMall: false,
      api: require("@/api/pdd/mall").default,
      notice: []
    };
  },
  created() {
    this.api.msg().then(res => {
      if (res.notice) {
        this.notice = res.notice.filter(x => new Date(x.date) > new Date());
        let cookie = this.$commonJs.getCookie("appmessage");
        if (!cookie) {
          this.$commonJs.setCookie("appmessage", "true", 1);
          if (this.notice.length > 0) this.openMsg();
        }
      }
    })
  },
  computed: {
    cachedViews() {
      return this.$store.state.tags.cachedViews;
    },
    key() {
      return this.$route.path;
    },
    mallList() {
      return this.$store.state.user.mallList;
    },
    mallInfo() {
      var sys_type = localStorage.getItem("sys_type");
      var data = {
        sysType: this.$platformJs.getName(sys_type),
      }
      var user_info = localStorage.getItem("user-info");
      if (user_info) {
        data = { ...data, ...JSON.parse(user_info) };
      }

      return data
    }
  },
  methods: {
    refreshView(name) {
      //隐藏组件
      this.refresh = false;
      //增加排除
      this.exclude = name;
      this.$nextTick((_) => {
        //删除排除
        this.exclude = null;
        //显示组件
        this.refresh = true;
      });
    },
    menuClick(url) {
      this.$router.push(url)
    },
    openMsg() {
      let html = "";
      this.notice.forEach(x => {
        let div = `<div style="line-height:22px;margin-bottom: 5px;">${x.msg}</div>`;
        html += div;
      })
      if (this.notice.length == 0) {
        html = `<div style="line-height:22px;text-align: center;color: #909399;">暂无消息</div>`
      }
      let msgbox = `<div style="max-height: 500px;overflow: auto;">${html}</div>`;
      this.$alert(msgbox, '消息提醒', {
        dangerouslyUseHTMLString: true,
        customClass: "notice",
      }).catch(() => { });
    },
    onSelectText(event) {
      console.log("event", event);
      // 获取一个Selection对象
      const selection = window.getSelection();
      // 先清空一下以选择的内容
      selection?.removeAllRanges();
      // 创建一个range对象
      const range = document.createRange();
      // 让range对象包含一个node的内容
      range.selectNodeContents(event.target);
      // 向selection中添加一个区域（range）
      selection?.addRange(range);
    },
    async logout() {
      await this.$store.dispatch("logout").then((res) => {
        this.$store.dispatch("clearStorage");
        window.location.reload();
      });
    },
    selectMall(mall) {
      // console.log("selectMall", mall);
      if (mall.day < 0) {
        this.$confirm(mall.mallName + ' 店铺已过期', '续费提醒', {
          confirmButtonText: '去续费',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          window.open("https://fuwu.pinduoduo.com/service-market/service-detail?detailId=86398")
        }).catch(() => { });
        return;
      }

      this.api.changemall(mall.secretKey).then(res => {
        if (res.errorCode) {
          this.$message.error(res.errorMessage);
        } else {
          localStorage.setItem("sys_type", "pdd");
          localStorage.setItem("token", res.accessToken);
          localStorage.setItem("user-info", JSON.stringify({
            logo: res.logoUrl,
            userName: res.userName,
            mallId: res.mallId,
            mallName: res.mallName,
            mainType: res.mainType,
            secretKey: res.secretKey,
            expirationDate: this.$commonJs.toDateString(res.expirationDate)
          }));
          var mall_list = [];
          if (res.mallInfos) {
            res.mallInfos.forEach(x => {
              mall_list.push({ logo: x.logoUrl, mallId: x.mallId, mallName: x.mallName, mainType: res.mainType, secretKey: x.secretKey, expirationDate: this.$commonJs.toDateString(x.expirationDate) })
            })
          } else {
            mall_list.push({ logo: res.logoUrl, mallId: res.mallId, mallName: res.mallName, mainType: res.mainType, secretKey: res.secretKey, expirationDate: this.$commonJs.toDateString(res.expirationDate) })
          }
          localStorage.setItem("mall_list", JSON.stringify(mall_list));
          window.location.reload();
        }
      })
    }
  }
};
</script>

<style lang="scss">
.notice {
  width: 500px !important;
}
</style>

<style lang="scss" scoped>
.app-head {
  position: fixed;
  z-index: 10;
  border-width: 0px;
  width: 100%;
  height: 64px;
  background-color: #001529;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  cursor: default;
  user-select: none;

  .title {
    font-weight: bold;
    width: 260px;
    text-align: center;
    line-height: 64px;
  }

  .menu {
    display: flex;
    align-items: center;
    width: calc(100% - 560px);

    .menu-item {
      width: 160px;
      text-align: center;
      line-height: 64px;
      cursor: pointer;
    }

    .active {
      background-color: #173551;
    }
  }

  .action {
    width: 300px;
    line-height: 64px;
    height: 100%;
    display: flex;
    justify-content: flex-end;

    .logo {
      width: 50px;
      display: flex;
      align-items: center;
      margin: unset;

      .el-image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
  }
}

.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 64px);
  padding-top: 64px;
  // padding: 20px;
  width: 100%;
  position: relative;
  // overflow: hidden;
}

.text-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-info {
  color: #ffffff;
  max-width: 140px;
  min-width: 100px;
  text-align: center;
  cursor: pointer;
  padding: 0 5px;
}

.day {
  color: #F56C6C;
  margin-right: 5px;
}

.user-info-box {
  width: 240px;
  position: relative;
  padding-bottom: 42px;

  .content {
    .item {
      line-height: 26px;
      display: flex;

      .label {
        width: 72px;
      }

      .item-content {
        width: calc(100% - 72px);
      }

    }
  }

  .footer-btn {
    border-top: 1px solid #dedede;
    position: absolute;
    bottom: 0;
    height: 32px;
    width: 100%;
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    .btn {
      color: #409EFF;
      cursor: pointer;
    }
  }
}

.mall-box {
  width: 300px;

  .mall-item {
    line-height: 32px;
    cursor: pointer;
    padding: 0 5px;
    display: flex;
    justify-content: space-between;

    .left {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 50px);
    }

    .right {
      text-align: right;
      width: 50px;
    }
  }

  .mall-item:hover {
    color: #ffffff;
    background-color: #79bbff;
  }
}
</style>